import { useStores, useWindowDimension } from 'hooks';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { MenuBar } from './MenuBar/MenuBar';
import { Settings } from './Settings/Settings';
import { Container } from './Styles';
import { RowView } from './Views/RowView';

export const SimLogViewer = observer(() => {
  const {
    DebuggerStore: {
      debuggerUpdated,
      logView,
      shouldShowLogViewer,
      shouldShowLogViewerInFullscreen,
      shouldWriteLogToDevWindow,
      showSettings,
    },
  } = useStores();
  const { winWidth } = useWindowDimension();
  const largerMonitor = winWidth > 1650;

  if (!shouldShowLogViewer) return null;

  return (
    <Container fullscreen={shouldShowLogViewerInFullscreen}>
      <MenuBar largerMonitor={largerMonitor} showSettings={showSettings} />
      {showSettings && (
        <Settings key={`debugger-settings-${debuggerUpdated}`} />
      )}
      {!showSettings && shouldWriteLogToDevWindow && (
        <RowView
          key={`debugger-RowView-${debuggerUpdated}`}
          largerMonitor={largerMonitor}
          view={logView}
        />
      )}
    </Container>
  );
});

export default SimLogViewer;
